<work-order-edit-form 
    [model]="model | async" 
    [users]="users | async | active" 
    [isNew]="false"
    (onSave)="saveWorkOrder($event)" 
></work-order-edit-form>
